import React from 'react';
import { Typography } from '@mui/material';
import { LotCostingMethod } from '../../interfaces/inventory/inventorySettings.interface';

const LABEL: Record<LotCostingMethod, string> = { FIFO: 'FIFO by lot', AVERAGE: 'Moving average' };

/** Dhaka calendar date of the switch instant, e.g. "8 Oct 2026". */
const switchDate = (iso?: string | null): string =>
  iso ? new Date(iso).toLocaleDateString('en-GB', { timeZone: 'Asia/Dhaka', day: 'numeric', month: 'short', year: 'numeric' }) : '';

/** G6b: how lot-tracked items are costed, stated in a report header ("Costing: Moving average (since 8 Oct 2026)"). */
export const costingBasisText = (method?: LotCostingMethod | null, since?: string | null): string => {
  const m: LotCostingMethod = method === 'AVERAGE' ? 'AVERAGE' : 'FIFO';
  return `Costing (lot-tracked items): ${LABEL[m]}${since ? ` (since ${switchDate(since)})` : ''}`;
};

const CostingBasisNote: React.FC<{ method?: LotCostingMethod | null; since?: string | null }> = ({ method, since }) => (
  <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }} data-testid="costing-basis">
    {costingBasisText(method, since)}
  </Typography>
);

export default CostingBasisNote;
